import { studyQueryKeys } from '@/config/queryKeys';
import { apiClient } from '@/lib/api-client';

/**
 * Revoke access to a study for a single user.
 * Throws if the API call fails.
 */
export const revokeStudyAccess = async (orgId: string, studyId: string, userId: string): Promise<void> => {
  await apiClient.delete(studyQueryKeys.endpoints.users(orgId, studyId), { user_ids: [userId] });
};
